import { render, staticRenderFns } from "./GrowerInfoCard.vue?vue&type=template&id=1d5f0763"
import script from "./GrowerInfoCard.vue?vue&type=script&lang=js"
export * from "./GrowerInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports